const user ={
    namespaced: true,
    state:{
        permission:[],
    },
    mutations:{
        SET_PERMISSION:(state, permission)=>{
            state.permission = permission
        }
    },
    actions:{
        permission ({ commit }, permission) {
            commit('SET_PERMISSION', permission)
        }
    }
}
export default user
